export default function Historico() {
    return (
        <div className="container mt-5">
            <h1>Histórico</h1>
        </div>
    )
}
